module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-19.a9f435e0.jpg";